import * as React from "react";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { User } from "../models/users";

export function LinksToAuthors({
  users,
  showTextInstead,
}: {
  users: User[];
  showTextInstead?: boolean;
}): JSX.Element {
  if (users.length === 0) {
    return <span>anonymous</span>;
  }

  const processedUsers = users.map((u) => {
    if (u.id === -1) {
      return { ...u, username: "anonymous" };
    }
    return u;
  });

  if (processedUsers.length === 1) {
    if (showTextInstead) {
      return (
        <span key={processedUsers[0].username}>
          {processedUsers[0].username}
        </span>
      );
    } else {
      return (
        <LinkToUser
          key={processedUsers[0].username}
          linkUser={processedUsers[0]}
        />
      );
    }
  }

  const result: JSX.Element[] = [];

  for (let i = 0; i < processedUsers.length; i++) {
    const user = processedUsers[i];

    if (showTextInstead) {
      result.push(<span key={user.username}>{user.username}</span>);
    } else {
      result.push(<LinkToUser key={user.username} linkUser={user} />);
    }

    if (i === processedUsers.length - 1) {
      // nothing
    } else if (i === processedUsers.length - 2) {
      result.push(<span key={`and-${i}`}> and </span>);
    } else {
      result.push(<span key={`comma-${i}`}>, </span>);
    }
  }

  return <span>{result}</span>;
}
